<!-- Two live regions stay in the page so screen readers hear each new message:
     a polite status for confirmations and notes, an alert for errors. -->
<div class="fb-anchor sticky top-0 z-50">
  <div class="feedback-card fb-rail" role="status">
    @if (showFeedBack && message && !isError) {
    <ng-container [ngTemplateOutlet]="card" />
    }
  </div>
  <div class="fb-rail" role="alert">
    @if (showFeedBack && message && isError) {
    <ng-container [ngTemplateOutlet]="card" />
    }
  </div>
</div>

<ng-template #card>
  <div
    [class]="merge('feedbackContent fb', cardClass)"
    [attr.data-tone]="feedBackType"
    (mouseenter)="pause()"
    (mouseleave)="resume()"
    (focusin)="pause()"
    (focusout)="resume()"
  >
    <span class="fb__dot" aria-hidden="true"></span>

    <div class="fb__text">
      @if(withTitle){
      <p class="fb__title">{{ heading }}</p>
      }
      <p class="fb__message feedback-message">{{ message }}</p>
    </div>

    <button
      type="button"
      class="close bk-icon-btn fb__close"
      aria-label="Dismiss notification"
      (click)="closeFeedback()"
    >
      <span class="bk-sym" aria-hidden="true">close</span>
    </button>
  </div>
</ng-template>
